const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const RenderingUtils = require('../utils/rendering');
const createReactClass = require('create-react-class');

const RadioGroup = createReactClass({
  propTypes: {
    onChange: PropTypes.func.isRequired,
    valueEqualityCheck: PropTypes.func,
    name: PropTypes.string,
    value: PropTypes.any,
    children: PropTypes.node,
  },

  childContextTypes: {
    radioGroup: PropTypes.shape({
      onChange: PropTypes.func,
      selectedValue: PropTypes.any,
      name: PropTypes.string,
    }),
  },

  mixins: [PureRenderMixin],

  getChildContext() {
    return {
      radioGroup: {
        onChange: this.props.onChange,
        valueEqualityCheck: this.props.valueEqualityCheck,
        selectedValue: this.props.value,
        name: this.props.name || this.backupName,
      },
    };
  },

  UNSAFE_componentWillMount() {
    this.backupName = RenderingUtils.uniqueId('vogue-radio-group');
  },

  render() {
    return <span>{ this.props.children }</span>;
  },
});

module.exports = RadioGroup;
